import React from "react";

import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import Icon from "Trackalyze/Icon";

import Flex from "Trackalyze/Flex";
import Menu, { MenuWrapper } from "Trackalyze/Menu";
import List, { ListItem } from "Trackalyze/List";
import Button from "Trackalyze/Button";
import TextField from "Trackalyze/TextField";
import Surface from "Trackalyze/Surface";
import Switch from "Trackalyze/Switch";
import Typo from "Trackalyze/Typo";
import Chip from "Trackalyze/Chip";
import Badge from "Trackalyze/Badge";
import Snackbar from "Trackalyze/Snackbar";
import Tooltip from "Trackalyze/Tooltip";
import Slider from "Trackalyze/Slider";
import ThemeSwitch from "../Settings/ThemeSwitch";
import Tabs from "Trackalyze/Tabs/Tabs";
import Tab from "Trackalyze/Tabs/Tab";
// Inside your react component
const GUI = () => {
  const [tabsSelected, setTabsSelected] = React.useState("");
  const [isDisabled, setIsDisabled] = React.useState(false);
  const [sliderVal, setSliderVal] = React.useState(50);
  const [sliderRangeVal, setSliderRangeVal] = React.useState([20, 80]);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <Surface level="0" className="ta-theme_light-" padding="xl">
      <Surface shape="l" padding="m" margin="m" elevated={1}>
        Level 1
      </Surface>
      <Surface shape="l" padding="m" margin="m" elevated={2}>
        Level 1
      </Surface>
      <Surface shape="l" padding="m" margin="m" elevated={3}>
        Level 1
      </Surface>
      <Flex vertical className="ta-background ta-view ta-view--size-l ">
        <Flex
          vertical
          flexitem
          spacing="4"
          padding="xxs"
          className="ta-is-overflow"
        >
          <div style={{ textAlign: "center" }}>
            <MenuWrapper>
              <Button icon symbol="add" tonal />
              <Menu transparent>
                <List>
                  <ListItem
                    leading={<Icon symbol="manage_accounts" />}
                    label="Test entry 1"
                  />
                  <ListItem
                    leading={<Icon symbol="manage_accounts" />}
                    label="Test entry 2"
                  />
                  <ListItem
                    leading={<Icon symbol="manage_accounts" />}
                    label="Test entry 3"
                  />
                </List>
              </Menu>
            </MenuWrapper>
          </div>

          <div style={{ textAlign: "center" }}>
            <MenuWrapper>
              <Button icon symbol="info" tonal />
              <Menu transparent>
                <List>
                  <ListItem
                    leading={<Icon symbol="manage_accounts" />}
                    label="Test entry 1"
                  />
                  <ListItem
                    leading={<Icon symbol="manage_accounts" />}
                    label="Test entry 2"
                  />
                  <ListItem
                    leading={<Icon symbol="manage_accounts" />}
                    label="Test entry 3"
                  />
                </List>
              </Menu>
            </MenuWrapper>
          </div>
        </Flex>
      </Flex>
      <Surface
        xstyle={{ width: "fit-content" }}
        padding="m"
        margin="m"
        className="ta-color_surface ta-flex ta-flex--column ta-gap_4"
      >
        <ThemeSwitch />
        <Flex
          itemscenter
          spacing="2"
          onClick={() => setIsDisabled(!isDisabled)}
        >
          <Typo type="label">Disabled</Typo>
          <Switch switched={isDisabled} />
        </Flex>
        <Tabs
          variant="secondary"
          value={tabsSelected}
          onChange={setTabsSelected}
        >
          <Tab value="tab1" label="Details" />
          <Tab value="tab2" label="Waypoints" />
          <Tab value="tab3" label="Splits" disabled />
          <Tab value="tab4" label="Profile" />
        </Tabs>
        <Flex wrap spacing="4" vertical padding="m">
          <Snackbar
            showClose
            fixed
            timeout={5000}
            label="Fixed Single line Snackbar without actions"
          />
          <Snackbar label="Single line Snackbar without actions" />
          <Snackbar label="Multi line Snackbar without actions. aaaa Multi line Snackbar without actions. Multi line Snackbar without action" />
          <Snackbar
            label="Single line Snackbar with actions, auto close 5s"
            actionLabel="Action button"
            showClose
            timeout={5000}
          />
          <Snackbar
            label="Multi line Snackbar without actions. aaaa Multi line Snackbar without actions. Multi line Snackbar without actions. aaaa Multi line Snackbar without actions. Multi line Snackbar. Multi line Snackbar without action"
            actionLabel="Action button"
            onAction={() => {
              console.log("Action button");
            }}
            showClose
          />

          <Tooltip
            rich
            subhead="Rich Tooltip Example"
            text="This is a fully featured rich tooltip including a subhead, body text, and interactive action buttons."
            position="right"
            actions={({ close }) => (
              <>
                <Button text size="s" onClick={close}>
                  Learn more
                </Button>
                <Button text size="s" onClick={close}>
                  Got it
                </Button>
              </>
            )}
          >
            <Button icon symbol="info" outline />
          </Tooltip>
          <Tooltip label="Plain Tooltip Example" position="right">
            <Button icon symbol="info" outline />
          </Tooltip>
        </Flex>

        <Flex wrap className="ta-gap_4">
          <Badge>1</Badge>

          <Badge>99</Badge>
          <Badge>9999</Badge>
          <Badge shape="squircle">New</Badge>
          <Badge max={10}>999999</Badge>

          <Badge small />
        </Flex>

        <Flex wrap className="ta-gap_4">
          <Chip symbol="info" disabled={isDisabled}>
            Chip None
          </Chip>
          <Chip symbol="info" filter disabled={isDisabled}>
            Chip Filter
          </Chip>
          <Chip symbol="info" filter selected disabled={isDisabled}>
            Chip Filter Selected
          </Chip>
          <Chip symbol="info" input disabled={isDisabled}>
            Chip input
          </Chip>
          <Chip symbol="info" input selected disabled={isDisabled}>
            Chip input Selected
          </Chip>
          <Chip symbol="info" assist disabled={isDisabled}>
            Chip assist
          </Chip>
          <Chip symbol="info" assist selected disabled={isDisabled}>
            Chip assist Selected
          </Chip>
        </Flex>
        <Flex wrap className="ta-gap_4">
          <Button size="xs" icon symbol="info" outline disabled={isDisabled} />
          <Button size="s" icon symbol="info" outline disabled={isDisabled} />
          <Button size="m" icon symbol="info" outline disabled={isDisabled} />
          <Button size="l" icon symbol="info" outline disabled={isDisabled} />
          <Button size="xl" icon symbol="info" outline disabled={isDisabled} />
        </Flex>
        <Flex wrap className="ta-gap_4">
          <Button
            badge
            badgeProps={{ small: true }}
            symbol="info"
            outline
            disabled={isDisabled}
          >
            Badge small
          </Button>
          <Button
            badge
            badgeProps={{ small: true }}
            symbol="info"
            outline
            icon
            disabled={isDisabled}
          />
          <Button badge={382} symbol="info" outline disabled={isDisabled}>
            Badg
          </Button>
          <Button symbol="info" filled size="xs" disabled={isDisabled}>
            Size XS
          </Button>
          <Button symbol="info" filled disabled={isDisabled}>
            Size default
          </Button>
          <Button symbol="info" filled size="s" disabled={isDisabled}>
            Size S
          </Button>
          <Button symbol="info" filled size="m" disabled={isDisabled}>
            Size M
          </Button>
          <Button symbol="info" filled size="l" disabled={isDisabled}>
            Size L
          </Button>
          <Button symbol="info" filled size="xl" disabled={isDisabled}>
            Size XL
          </Button>
        </Flex>
        <Flex wrap className="ta-gap_4">
          <Button symbol="info" disabled={isDisabled}>
            None
          </Button>
          <Button symbol="info" filled disabled={isDisabled}>
            Filled
          </Button>
          <Button symbol="info" tonal disabled={isDisabled}>
            Tonal
          </Button>
          <Button symbol="info" outline disabled={isDisabled}>
            Outline
          </Button>
          <Button symbol="info" text disabled={isDisabled}>
            Text
          </Button>
        </Flex>
        <Flex wrap className="ta-gap_4">
          <Button symbol="info" filled toggle disabled={isDisabled}>
            Filled Toggle
          </Button>
          <Button symbol="info" tonal toggle disabled={isDisabled}>
            Tonal Toggle
          </Button>
          <Button symbol="info" outline toggle disabled={isDisabled}>
            Outline Toggle
          </Button>
          <Button symbol="info" text toggle disabled={isDisabled}>
            Text Toggle
          </Button>
        </Flex>
        <Flex wrap className="ta-gap_4">
          <Button symbol="info" filled toggle selected disabled={isDisabled}>
            Filled Toggle selected
          </Button>
          <Button symbol="info" tonal toggle selected disabled={isDisabled}>
            Tonal Toggle selected
          </Button>
          <Button symbol="info" outline toggle selected disabled={isDisabled}>
            Outline Toggle selected
          </Button>
          <Button symbol="info" text toggle selected disabled={isDisabled}>
            Text Toggle selected
          </Button>
        </Flex>

        <Flex wrap className="ta-gap_4" vertical>
          <Typo type="title" size="m">
            Sliders
          </Typo>

          <Flex
            vertical
            spacing="2"
            style={{ width: "100%", maxWidth: "300px" }}
          >
            <Typo type="label">Continuous (Default)</Typo>
            Slider xs:
            <Slider
              value={sliderVal}
              onChange={setSliderVal}
              disabled={isDisabled}
              size="xs"
            />
            Slider s:
            <Slider
              value={sliderVal}
              onChange={setSliderVal}
              disabled={isDisabled}
              size="s"
            />
            Slider m:
            <Slider
              orientation="vertical"
              value={sliderVal}
              onChange={setSliderVal}
              disabled={isDisabled}
              size="m"
            />
            Slider l:
            <Slider
              value={sliderVal}
              onChange={setSliderVal}
              disabled={isDisabled}
              size="l"
            />
            Slider xl:
            <Slider
              value={sliderVal}
              onChange={setSliderVal}
              disabled={isDisabled}
              size="xl"
            />
          </Flex>

          <Flex
            vertical
            spacing="2"
            style={{ width: "100%", maxWidth: "400px" }}
          >
            <Typo type="label">Discrete with Tooltip</Typo>
            <Slider
              value={sliderVal}
              onChange={setSliderVal}
              step={10}
              marks
              valueLabel
              disabled={isDisabled}
              size="l"
            />
          </Flex>

          <Flex
            vertical
            spacing="2"
            style={{ width: "100%", maxWidth: "400px" }}
          >
            <Typo type="label">Range Slider</Typo>
            <Slider
              value={sliderRangeVal}
              onChange={setSliderRangeVal}
              valueLabel
              disabled={isDisabled}
              size="l"
            />
          </Flex>
        </Flex>
      </Surface>
      <Flex className="ta-theme_light ta-color_surface">
        <div className="ta-color-text_on-surface">Text surface</div>
        <div className="ta-color-text_on-surface-variant">Text variant</div>
        <div className="ta-color-text_on-surface-low">Text Low</div>
        <div className="ta-color-text_on-surface-lowest">Text Lowest</div>
        <Surface
          style={{ width: "fit-content" }}
          padding="m"
          margin="m"
          className="ta-color_surface-container-lowest"
        >
          Lowest
        </Surface>
        <Surface
          style={{ width: "fit-content" }}
          padding="m"
          margin="m"
          className="ta-color_surface-container-low"
        >
          Low
        </Surface>
        <Surface
          style={{ width: "fit-content" }}
          padding="m"
          margin="m"
          className="ta-color_surface-container"
        >
          Normal
        </Surface>
        <Surface
          style={{ width: "fit-content" }}
          padding="m"
          margin="m"
          className="ta-color_surface-container-high"
        >
          High
        </Surface>
        <Surface
          style={{ width: "fit-content" }}
          padding="m"
          margin="m"
          className="ta-color_surface-container-highest"
        >
          Highest
        </Surface>
      </Flex>
      <Flex className="ta-theme_dark ta-color_surface">
        <div className="ta-color-text_on-surface">Text surface</div>
        <div className="ta-color-text_on-surface-variant">Text variant</div>
        <div className="ta-color-text_on-surface-low">Text Low</div>
        <div className="ta-color-text_on-surface-lowest">Text Lowest</div>
        <Surface
          style={{ width: "fit-content" }}
          padding="m"
          margin="m"
          className="ta-color_surface-container-lowest"
        >
          Lowest
        </Surface>
        <Surface
          style={{ width: "fit-content" }}
          padding="m"
          margin="m"
          className="ta-color_surface-container-low"
        >
          Low
        </Surface>
        <Surface
          style={{ width: "fit-content" }}
          padding="m"
          margin="m"
          className="ta-color_surface-container"
        >
          Normal
        </Surface>
        <Surface
          style={{ width: "fit-content" }}
          padding="m"
          margin="m"
          className="ta-color_surface-container-high"
        >
          High
        </Surface>
        <Surface
          style={{ width: "fit-content" }}
          padding="m"
          margin="m"
          className="ta-color_surface-container-highest"
        >
          Highest
        </Surface>
      </Flex>
      <Surface
        elevated="1"
        style={{ width: "fit-content" }}
        shape="l"
        padding="l"
        margin="l"
      >
        Raised 1
      </Surface>
      <Surface
        elevated="2"
        style={{ width: "fit-content" }}
        shape="l"
        padding="l"
        margin="l"
      >
        Raised 2
      </Surface>
      <Surface
        elevated="3"
        style={{ width: "fit-content" }}
        shape="l"
        padding="l"
        margin="l"
      >
        Raised 3
      </Surface>
      <Surface
        outline
        style={{ width: "fit-content" }}
        shape="l"
        padding="xs"
        margin="l"
      >
        <TextField
          label={t("profile.formAgeLabel")}
          value={""}
          onChange={(value) => {
            console.log(value);
          }}
          reset
        />
      </Surface>
      <Surface
        outline
        level="1"
        style={{ width: "fit-content" }}
        shape="l"
        padding="xs"
        margin="l"
      >
        <TextField
          label={t("profile.formAgeLabel")}
          value={""}
          onChange={(value) => {
            console.log(value);
          }}
          reset
        />
      </Surface>
      <Surface
        outline
        level="2"
        style={{ width: "fit-content" }}
        shape="l"
        padding="xs"
        margin="l"
      >
        <TextField
          label={t("profile.formAgeLabel")}
          value={""}
          onChange={(value) => {
            console.log(value);
          }}
          leading="info"
          trailing="settings"
          reset
        />
      </Surface>
      <Surface
        outline
        level="3"
        style={{ width: "fit-content" }}
        shape="l"
        padding="xs"
        margin="l"
      >
        <TextField
          type="number"
          label={t("profile.formAgeLabel")}
          value={""}
          onChange={(value) => {
            console.log(value);
          }}
          className="ta-margin_leftright-xxxs"
          support={t("profile.formAgeSupport")}
        />
      </Surface>
    </Surface>
  );
};

export default React.memo(GUI);
